import React, { useEffect, useState } from 'react';

/*
  Wave G-A · Chat latency perception fix.
  Renders inside the assistant bubble while streaming hasn't yet
  produced its first token. Auto-cycles three calm reassurance lines
  every ~6 seconds so the user never sits in front of a silent UI
  during the 30-50s LLM round-trip.

  Disappears the moment any real content arrives (caller renders this
  ONLY when `msg.streaming && !msg.content`).
*/
const STAGES = [
  'Reviewing your question',
  'Checking your health context',
  'Preparing a clear response',
];

const ROTATE_MS = 6000;

export const StreamingProgress = () => {
  const [idx, setIdx] = useState(0);

  useEffect(() => {
    // Cap at the last stage so we never wrap back to "Reviewing…"
    // — that would feel like the model restarted.
    const t = setInterval(() => {
      setIdx((current) => (current < STAGES.length - 1 ? current + 1 : current));
    }, ROTATE_MS);
    return () => clearInterval(t);
  }, []);

  return (
    <div
      className="flex items-center gap-2 py-1"
      data-testid="chat-streaming-progress"
      aria-live="polite"
    >
      <span className="flex items-center gap-1">
        <span className="w-1.5 h-1.5 bg-slate-300 rounded-full animate-pulse" />
        <span
          className="w-1.5 h-1.5 bg-slate-300 rounded-full animate-pulse"
          style={{ animationDelay: '0.15s' }}
        />
        <span
          className="w-1.5 h-1.5 bg-slate-300 rounded-full animate-pulse"
          style={{ animationDelay: '0.3s' }}
        />
      </span>
      <span
        key={idx}
        className="text-sm text-slate-500 transition-opacity duration-500"
        data-testid={`chat-streaming-stage-${idx}`}
      >
        {STAGES[idx]}
      </span>
    </div>
  );
};

export default StreamingProgress;
